module.exports = __webpack_public_path__ + "static/img/bg.02102f2a.jpg";